





































import Vue from 'vue'
import {mapActions, mapState, mapGetters} from 'vuex'
// moment
import moment from 'moment'
import 'moment/locale/it'

export default Vue.extend({
    data: () => ({
        urlPhoto: ''
    }),
    computed: {
        ...mapGetters('user', ['eUnOperatoreGestionaleReport']),
        ...mapState('reportMappa', ['segnalazioneMostrata'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        // la data di rilevamento scritta in modo leggibile
        dataParsata: (data) => moment(data).format('DD MMMM YYYY')
    },
    mounted() {
        // date italiane
        moment.locale('it')
    }
})
